// Ref link : https://www.sohamkamani.com/javascript/localstorage-with-ttl-expiry/
// Helper class to manage local cache in better way

export function setCache(key, value, ttlMinutes) {
  const now = new Date()
  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value,
    expiry: now.getTime() + (ttlMinutes * 60 * 1000), // to milliseconds
  }

  localStorage.setItem(key, JSON.stringify(item))
}

export function getCache(key) {
  const itemStr = localStorage.getItem(key)

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null
  }

  const item = JSON.parse(itemStr)
  const now = new Date()

  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key)
    return null
  }
  return item.value
}

// call the action and store the response in local storage for frequent access and better UI experience
export default async function dispatchCached(dispatch, actionName, ttlMinutes = 60) {
  const cacheKey = actionName
  let data = getCache(cacheKey)
  if (data) { return data }
  data = await dispatch(actionName)
  setCache(cacheKey, data, ttlMinutes)
  return data
}
